import React from "react";
import { StyledPara } from "./styled/Header";
var AccordionHeader = function (_a) {
    var showText = _a.renderProps.showText;
    return (React.createElement(StyledPara, { large: true, bold: true }, showText));
};
export default AccordionHeader;
